import { useState, useRef, useEffect } from 'react';
import api from '../../utils/api';

export default function DashboardSearch({ endpoint }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selected, setSelected] = useState(null);
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (value) => {
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!value.trim()) { setResults([]); setShowDropdown(false); return; }
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await api.get(`${endpoint}?q=${encodeURIComponent(value.trim())}`);
        setResults(res.data.results || []);
        setShowDropdown(true);
      } catch { setResults([]); }
    }, 300);
  };

  return (
    <>
      <div className="dash-search-wrapper" ref={wrapperRef}>
        <div className="dash-search-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </div>
        <input
          type="text"
          className="dash-search-input"
          placeholder="Search tenants by name, email, unit, or building..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          onFocus={() => { if (results.length) setShowDropdown(true); }}
        />
        {showDropdown && results.length > 0 && (
          <div className="dash-search-dropdown">
            {results.map((r) => (
              <button
                key={r.id}
                className="dash-search-result"
                onClick={() => { setSelected(r); setShowDropdown(false); }}
              >
                <span className="dash-search-name">{r.first_name} {r.last_name}</span>
                <span className="dash-search-meta">
                  {r.unit_number ? `Unit ${r.unit_number}` : ''}{r.unit_number && r.property_name ? ' · ' : ''}{r.property_name || ''}
                </span>
              </button>
            ))}
          </div>
        )}
        {showDropdown && results.length === 0 && query.trim() && (
          <div className="dash-search-dropdown">
            <div className="dash-search-empty">No results found</div>
          </div>
        )}
      </div>

      {selected && (
        <div className="topbar-modal-overlay" onClick={() => setSelected(null)}>
          <div className="topbar-modal" onClick={(e) => e.stopPropagation()}>
            <div className="topbar-modal-header">
              <h3>Tenant Details</h3>
              <button className="topbar-modal-close" onClick={() => setSelected(null)}>&times;</button>
            </div>
            <div className="topbar-modal-body">
              <div className="topbar-modal-row"><span className="topbar-modal-label">Name</span><span>{selected.first_name} {selected.last_name}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Email</span><span>{selected.email}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Phone</span><span>{selected.phone || '—'}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Unit</span><span>{selected.unit_number || '—'}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Property</span><span>{selected.property_name || '—'}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Status</span><span className={`topbar-modal-status topbar-modal-status--${selected.status}`}>{selected.status}</span></div>
              <div className="topbar-modal-row"><span className="topbar-modal-label">Lease Type</span><span>{selected.lease_type || '—'}</span></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
